import * as z from "zod";

import { parseValidThru } from "@shared/utils/date.utils";

export const CardDtoSchema = z
  .object({
    CardHolder: z.string().min(6).max(255),
    CardNumber: z.string().min(10).max(19),
    ValidThru: z.string().regex(/^\d{2}\/\d{2}$/),
    CVV: z.string().regex(/^\d{3}$/),
  })
  .transform((payload) => {
    const { month, year } = parseValidThru(payload.ValidThru);

    return {
      Holder: payload.CardHolder,
      Number: payload.CardNumber.replace(/\D/g, ""),
      DueAt: `${month}/${year}`,
      SecurityCode: payload.CVV,
    };
  });
